import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import Dashboard from './view/Dashboard.vue'
import Funcionario from './view/Funcionario.vue'
import UnidadeMedida from './view/UnidadeMedida.vue'
import EnderecoOrdemServico from './view/EnderecoOrdemServico.vue'
import Dispensa from './view/Dispensa'
import ReceberItem from './view/ReceberItem.vue'
import Paciente from './view/Paciente.vue'
import SolicitarItem from './view/SolicitarItem.vue'
import DispensaSetor from './view/DispensaSetor.vue'
import DispensaSetorAdm from './view/DispensaSetorAdm.vue'
import DispensaPacienteAdm from './view/DispensaPacienteAdm.vue'
import DispensaSubestoque from './view/DispensaSubestoque.vue'
import SolicitacoesDeItens from './view/SolicitacoesDeItens.vue'
import SolicitacoesDeKits from './view/SolicitacoesDeKits.vue'
import RelatorioSolicitacoesItens from './view/RelatorioSolicitacoesItens.vue'
import ItensNDispensados from './view/itensNDispensados.vue'
import HistoricoDeDispensa from './view/HistoricoDeDispensa.vue'
import HistoricoEntrada from './view/HistoricoEntrada'
import Blacklist from './view/Blacklist.vue'
import Whitelist from './view/Whitelist.vue'
import EstoqueUnidade from './view/EstoqueUnidade.vue'
import Itens from './view/Itens.vue'
import ItemSistema from './view/ItemSistema.vue'
import ItemSistemaUnidade from './view/ItemSistemaUnidade.vue'
import ItensUnidade from './view/ItensUnidade.vue'
import Kit from './view/Kit.vue'
import Subestoque from './view/Subestoque.vue'
import SetorUnidade from './view/SetorUnidade.vue'
import RelatorioMovimentacao from './view/RelatorioMovimentacao.vue'
import RelatorioSaida from './view/RelatorioSaida.vue'
import RelatorioSaidaPaciente from './view/RelatorioSaidaPaciente.vue'
import RelatorioSaidaMensal from './view/RelatorioSaidaMensal.vue'
import RelatorioSaidaMensalAdm from './view/RelatorioSaidaMensalAdm.vue'
import login from './view/login.vue'
import perfil from './view/perfil.vue'
import importarNota from './view/importarNota.vue'
import importarNotaAdm from './view/importarNotaAdmin.vue'
import SolicitacaoRegistro from './view/SolicitacaoRegistro.vue'
import axios from './plugins/axios'
import dispensaPacienteUnidade from './view/DispensaPacienteUnidade'
import RelatorioAlteracoes from './view/RelatorioAlteracoes'
import RelatorioAlteracoesADM from './view/RelatorioAlteracoesADM'
import RelatorioEntradasNota from './view/RelatorioEntradasNota'
import RelatorioEntradasNotaADM from './view/RelatorioEntradasNotaADM'
import DispensaKit from './view/DispensaKit'
import RelatorioRastreioKits from './view/RelatorioRastreioKits'
import RelatorioRastreioKitsADM from './view/RelatorioRastreioKitsADM'
import AprovarDispensaUnidade from './view/AprovarDispensaUnidade'
import DispensaUnidade from './view/DispensaUnidade'
import ConfiguracaoPedido from './view/ConfiguracaoPedido.vue'


Vue.use(Router)

/*
  Verifica se o usuário esta autenticado e o token é valido. Caso esteja, renderiza a pagina destino
  caso não esteja autenticado ou o token seja invalido, renderiza a pagina de login e apaga o token do localStorage
  se tentar acessar /login autenticado e com token valido, é redirecionado para a pagina "/" (Home).
*/
const ifAuthenticatedRenderPageElseRenderLogin = async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      await axios.post("/verifyToken", null, {
        headers: {
          "x-auth-token": store.getters.token
        }
      })

      const infoUser = await axios.get('/info', {
        headers: {
          "x-auth-token": store.getters.token
        }
      })

      store.dispatch("setNome", infoUser.data.nomeFuncionario)
      store.dispatch("setNivelUsuario", infoUser.data.indicadorNivelAcesso)
      store.dispatch('setNomeEndereco', infoUser.data.enderecoOrdemServico.nomeEndereco)

      next()
    } catch (error) {
      store.dispatch("setToken", "")
      store.dispatch("setAuthenticatedState", false)

      next("/login")
    }
  } else {
    next();
  }
}

/*
  Se o usuário estiver autenticado, o componente de login não é renderizado. É redirecionado
  para a Home "/".
*/
const doNotRenderLoginIfAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next({
      path: '/'
    })
  } else {
    next()
  }
}


//Toda rota do aplicativo será registrada aqui.
const router = new Router({
  mode: 'history',
  history: true,
  routes: [
    {
      path: '/',
      name: "Dashboard",
      component: Dashboard,
      meta: { requiresAuth: true }
    },
    {
      path: '/funcionario',
      name: 'Funcionario',
      component: Funcionario,
      meta: { requiresAuth: true }
    },
    {
      path: '/configuracaopedidos',
      name: 'ConfiguracaoPedido',
      component: ConfiguracaoPedido,
      meta: { requiresAuth: true }
    },
    {
      path: '/UnidadeMedida',
      name: 'UnidadeMedida',
      component: UnidadeMedida,
      meta: { requiresAuth: true }
    },
    {
      path: '/produtosSistema',
      name: 'ProdutosSistema',
      component: ItemSistema,
      meta: { requiresAuth: true }
    },
    {
      path: '/produtos',
      name: 'Produtos',
      component: Itens,
      meta: { requiresAuth: true }
    },
    {
      path: '/produtosndispensados',
      name: 'ProdutosNDispensados',
      component: ItensNDispensados,
      meta: { requiresAuth: true }
    },
    {
      path: '/produtosUnidade',
      name: 'ProdutosUnidade',
      component: ItensUnidade,
      meta: { requiresAuth: true }
    },
    {
      path: '/produtosSistemaUnidade',
      name: 'ProdutoSistemaUnidade',
      component: ItemSistemaUnidade,
      meta: { requiresAuth: true }
    },
    {
      path: '/estoqueUnidade',
      name: 'EstoqueUnidade',
      component: EstoqueUnidade,
      meta: { requiresAuth: true }
    },
    {
      path: '/enderecoOrdemServico',
      name: 'Endereços das O.S',
      component: EnderecoOrdemServico,
      meta: { requiresAuth: true }
    },
    {
      path: "/dispensa",
      name: "dispensa",
      component: Dispensa,
      meta: { requiresAuth: true }
    },
    {
      path: "/receberProduto",
      name: "Receber Produto",
      component: ReceberItem,
      meta: { requiresAuth: true }
    },
    {
      path: "/solicitarProdutos",
      name: "Solicitar Produtos",
      component: SolicitarItem,
      meta: { requiresAuth: true }
    },
    {
      path: "/dispensaSetor",
      name: "Dispensa Setor",
      component: DispensaSetor,
      meta: { requiresAuth: true }
    },
    {
      path: "/dispensasDeSetores",
      name: "Dispensas de Setores",
      component: DispensaSetorAdm,
      meta: { requiresAuth: true }
    },
    {
      path: "/dispensaSubestoque",
      name: "DispensaSubestoque",
      component: DispensaSubestoque,
      meta: { requiresAuth: true }
    },
  
    {
      path: "/login",
      name: "login",
      component: login,
      beforeEnter: doNotRenderLoginIfAuthenticated
    },
    {
      path: '/historicoEntrada',
      name: 'Historico De Entrada',
      component: HistoricoEntrada,
      meta: { requiresAuth: true }
    },
    {
      path: '/historicoDeDispensa',
      name: 'Historico De Dispensa',
      component: HistoricoDeDispensa,
      meta: { requiresAuth: true }
    },
    {
      path: "/blacklist",
      name: "Blacklists",
      component: Blacklist,
      meta: { requiresAuth: true }
    },
    {
      path: "/whitelist",
      name: "Whitelists",
      component: Whitelist,
      meta: { requiresAuth: true }
    },
    {
      path: "/solicitacoesDeProdutos",
      name: "Solicitações de Produtos",
      component: SolicitacoesDeItens,
      meta: { requiresAuth: true }
    },
    {
      path: "/solicitacoesDeKits",
      name: "Solicitações de Kits",
      component: SolicitacoesDeKits,
      meta: { requiresAuth: true }
    },
    {
      path: "/relatorioSolicitacoesProdutos",
      name: "Relatorio de Solicitações de Produtos",
      component: RelatorioSolicitacoesItens,
      meta: { requiresAuth: true }
    },
    {
      path: "/perfil",
      name: "perfil",
      component: perfil,
      meta: { requiresAuth: true }
    },
    {
      path: "/kit",
      name: "Kit",
      component: Kit,
      meta: { requiresAuth: true }
    },
    {
      path: "/subestoque",
      name: "Subestoque",
      component: Subestoque,
      meta: { requiresAuth: true }
    },
    {
      path: "/setorUnidade",
      name: "SetorUnidade",
      component: SetorUnidade,
      meta: { requiresAuth: true }
    },
    {
      path: "/relatorioMovimentacao",
      name: "Relatório de Movimentação",
      component: RelatorioMovimentacao,
      meta: { requiresAuth: true }
    },
    {
      path: "/relatorioSaida",
      name: "Relatório de Saida",
      component: RelatorioSaida,
      meta: { requiresAuth: true }
    },
    {
      path: "/relatorioSaidaPaciente",
      name: "Relatório de Saida Paciente",
      component: RelatorioSaidaPaciente,
      meta: { requiresAuth: true }
    },
    {
      path: "/relatorioSaidaMensal",
      name: "Placar de Movimentação Mensal/Anual",
      component: RelatorioSaidaMensal,
      meta: { requiresAuth: true }
    },
    {
      path: "/relatorioSaidaMensalAdm",
      name: "Placar de Movimentação Mensal por Unidade",
      component: RelatorioSaidaMensalAdm,
      meta: { requiresAuth: true }
    },
    {
      path: "/pacientes",
      name: "Pacientes",
      component: Paciente,
      meta: { requiresAuth: true }
    },
    {
      path: "/dispensaPacientes",
      name: "Dispensa de Pacientes",
      component: DispensaPacienteAdm,
      meta: { requiresAuth: true }
    },
    {
      path: "/importarNota",
      name: "Importar notas",
      component: importarNota,
      meta: { requiresAuth: true }
    },
    {
      path: "/importarNotaAdm",
      name: "Importar Nota",
      component: importarNotaAdm,
      meta: { requiresAuth: true }
    },
    {
      path: "/solicitacaoregistro",
      name: "Solicitações Registro",
      component: SolicitacaoRegistro,
      meta: { requiresAuth: true }
    },
    {
      path: "/dispensaPacienteUnidade",
      name: "Dispensa Paciente Unidade",
      component: dispensaPacienteUnidade,
      meta: {requiresAuth: true}
    },
    {
      path: "/relatorioalteracoes",
      name: "Relatório de Alterações",
      component: RelatorioAlteracoesADM,
      meta: {requiresAuth: true}
    },
    {
      path: "/relatorioalteracoesunidade",
      name: "Relatório de Alterações Unidade",
      component: RelatorioAlteracoes,
      meta: {requiresAuth: true}
    },
    {
      path: "/relatorioentradas",
      name: "Relatório de Entradas",
      component: RelatorioEntradasNotaADM,
      meta: {requiresAuth: true}
    },
    {
      path: "/relatorioentradasunidade",
      name: "Relatório de Entradas Unidade",
      component: RelatorioEntradasNota,
      meta: {requiresAuth: true}
    },
    {
      path: "/dispensakit",
      name: "Dispensas de Kits",
      component: DispensaKit,
      meta: {requiresAuth: true}
    },
    {
      path: "/relatoriodispensakitsunidade",
      name: "Relatório Dispensas de Kits",
      component: RelatorioRastreioKits,
      meta: {requiresAuth: true}
    },
    {
      path: "/relatoriodispensakits",
      name: "Relatório Dispensas de Kits ADM",
      component: RelatorioRastreioKitsADM,
      meta: {requiresAuth: true}
    },
    {
      path: "/aprovardispensaunidade",
      name: "Aprovar Dispensa Unidade",
      component: AprovarDispensaUnidade,
      meta: {requiresAuth: true}
    },
    {
      path: "/dispensaunidade",
      name: "Dispensa Unidade",
      component: DispensaUnidade,
      meta: {requiresAuth: true}
    },
  ]
});

router.beforeEach(ifAuthenticatedRenderPageElseRenderLogin);

export default router;